<section>
    <div class="info">
        <div class="info-icon">
            <xm-media-image aria-hidden="true" [imageOptions]="tabletIcon" size="width"></xm-media-image>
        </div>

        <div class="data">
            <h4 class="plan-name">{{ getCurrentPlan(cmsSeg5TabletData.header) }}</h4>
            <span class="plan-price">{{ cmsSeg5TabletData.subHeader }}</span>
            <p class="plan-subheader">{{ cmsSeg5TabletData.description }}</p>
        </div>

        <div class="action" role="status" [attr.aria-label]="getCurrentPlan(cmsSeg5TabletData.header) + ' is ' + pageData.inUse">
            <xm-media-image [imageOptions]="inUseIcon" class="use-icon" center="auto" size="auto"></xm-media-image>
            <span class="action-text">{{ pageData.inUse }}</span>
        </div>
    </div>
    <div class="features" *ngIf="isBusinessUser">
        <div class="active-plan-feature">
            <h4 class="feature-header">
                {{ featureTitle }}
            </h4>
            <div class="features-content">
                <div *ngFor="let feature of dataFeatures" class="plan-feature">
                    <xm-media-image aria-hidden="true" [imageOptions]="generateFeatureIcon(feature.icon)"
                        class="plan-feature-icon"></xm-media-image>
                    <div class="plan-feature-description">
                        <h4 class="plan-feature-header">{{ feature.header }}</h4>
                        <p class="plan-feature-subheader">{{ feature.subheader }}</p>
                    </div>
                </div>
            </div>
        </div>
        <ng-content></ng-content>
    </div>
</section>
